import { getCookie } from 'react-simple-cookie-store';
import { isEmpty } from 'validator';
import { AccessToken } from './AccessToken';
export var getBearerToken = function () {
    var access = getCookie(AccessToken.Access) || '';
    var temporary = getCookie(AccessToken.Temporary) || '';
    return isEmpty(access) ? temporary : access;
};
